export const DISCUSSION_PREFERENCES_QUERY = '/discussion/preferences';
export const ASSOCIATED_DISCUSSION_QUERY = '/discussions/associated';
export const DISCUSSIONS_INBOX_QUERY = '/discussions/inbox';
